
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Brain, Database, Users, LineChart, Globe } from "lucide-react";

const dimensions = [
  {
    icon: Brain,
    title: "Strategy & Leadership",
    description: "Organizational AI vision and leadership commitment."
  },
  {
    icon: Database,
    title: "Data & Infrastructure",
    description: "Data readiness and technological capabilities."
  },
  {
    icon: Users,
    title: "Talent & Skills",
    description: "Availability of AI-trained workforce."
  },
  {
    icon: LineChart,
    title: "AI Use Case Deployment",
    description: "Implementation and business impact of AI projects."
  },
  {
    icon: Globe,
    title: "Innovation & Ecosystem",
    description: "AI-driven partnerships and external collaboration."
  }
];

const benchmarkingApproach = [
  "Data sourced from McKinsey, Gartner, MIT Sloan, Deloitte, and PwC AI research.",
  "Weighted scoring model ensuring accurate industry-specific AI maturity insights.",
  "AI-powered analysis adapts to real-time AI trends and enterprise adoption patterns.",
  "Continuous updates based on emerging AI technologies and industry best practices."
];

export const HowAIMAAWorks = () => {
  return (
    <section className="mb-8 sm:mb-16 animate-fade-in" style={{ animationDelay: "150ms" }}>
      <h2 className="text-xl sm:text-2xl font-semibold text-[#0f2d69] mb-4 sm:mb-6">How AIMAA Works</h2>
      <Card className="bg-white/50 mb-6 sm:mb-8 hover:shadow-lg transition-all duration-300">
        <CardContent className="pt-6">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {dimensions.map((dim, index) => (
              <div 
                key={index} 
                className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-1"
              >
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2 bg-[#0f2d69]/5 rounded-lg">
                    <dim.icon className="h-5 w-5 text-[#0f2d69]" />
                  </div>
                  <h3 className="font-semibold text-[#0f2d69]">{dim.title}</h3>
                </div>
                <p className="text-sm text-gray-600">{dim.description}</p>
              </div>
            ))}
          </div>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed mt-6">
            AIMAA uses a comprehensive 50-question assessment to analyze these dimensions. The results are benchmarked 
            against real-time industry trends and global AI adoption data to provide actionable insights.
          </p>
        </CardContent>
      </Card>

      <Card className="bg-white/50 hover:shadow-lg transition-all duration-300">
        <CardHeader>
          <CardTitle className="text-lg sm:text-xl">Our Benchmarking Approach</CardTitle>
        </CardHeader>
        <CardContent>
          <ul className="space-y-2 sm:space-y-3 text-sm sm:text-base text-gray-600">
            {benchmarkingApproach.map((item, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="text-[#0f2d69] font-semibold">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      </Card>
    </section>
  );
};
